import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { store } from "./store";
import { Provider } from "react-redux";
import { ToastNotificationProvider } from "./components/toastNotificationProvider/ToastNotificationProvider";
import theme from "./constant/theme/theme";



ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <ChakraProvider theme={theme}>
    <ToastNotificationProvider>
      <Provider store={store}>
        <App />
      </Provider>
      </ToastNotificationProvider>
    </ChakraProvider>
  </BrowserRouter>
);
